"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../styles/styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const Button = props => {
  const {
    type,
    hidden,
    pressed,
    checked,
    onText,
    offText,
    classNameToggleActive,
    classNameToggleInActive,
    className = "",
    labelId
  } = props,
        rest = _objectWithoutProperties(props, ["type", "hidden", "pressed", "checked", "onText", "offText", "classNameToggleActive", "classNameToggleInActive", "className", "labelId"]);

  if (type === "toggle") {
    return _react.default.createElement("button", _extends({}, rest, {
      type: "button",
      className: hidden ? `ric-hidden ${className}` : className,
      "aria-pressed": pressed
    }));
  }

  if (type === "toggle-dynamic") {
    return _react.default.createElement("button", _extends({}, rest, {
      type: "button",
      className: hidden ? `ric-hidden ${className}` : className,
      "aria-labelledby": labelId ? labelId : null,
      "aria-checked": checked
    }));
  }

  if (type === "switch") {
    return _react.default.createElement("button", _extends({}, rest, {
      type: "button",
      className: hidden ? `ric-hidden ${className}` : className,
      role: "switch",
      "aria-checked": checked,
      "aria-labelledby": labelId ? labelId : null
    }), _react.default.createElement("span", {
      className: classNameToggleActive
    }, onText), _react.default.createElement("span", {
      className: classNameToggleInActive
    }, offText));
  }

  return _react.default.createElement("button", _extends({}, rest, {
    type: type,
    className: hidden ? `ric-hidden ${className}` : className
  }));
};

Button.propTypes = {
  hidden: _propTypes.default.bool,
  type: _propTypes.default.string,
  pressed: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  onText: _propTypes.default.string,
  offText: _propTypes.default.string,
  classNameToggleActive: _propTypes.default.string,
  classNameToggleInActive: _propTypes.default.string,
  labelId: _propTypes.default.string
};
Button.defaultProps = {
  type: "button",
  pressed: false,
  checked: false
};
var _default = Button;
exports.default = _default;